// Large sprite preview image for units and cities shown in info panels.
// Uses the same texture paths as the 3D renderer (spriteMapping.ts).

import { cityTexturePath, unitTexturePath } from '../../render/spriteMapping.js';

interface SpritePreviewProps {
  readonly textureUrl: string;
  readonly label: string;
}

export function SpritePreview({ textureUrl, label }: SpritePreviewProps) {
  return (
    <div className="flex flex-col items-center gap-1.5">
      <div className="flex size-24 items-center justify-center rounded-lg bg-muted/20 border border-border/40 overflow-hidden">
        <img
          src={textureUrl}
          alt={label}
          className="max-h-full max-w-full object-contain"
          style={{ imageRendering: 'auto' }}
        />
      </div>
      <span className="text-[10px] text-muted-foreground truncate max-w-[120px]">{label}</span>
    </div>
  );
}

/** Build a preview URL for a unit scene node. */
export function unitPreviewUrl(node: { props?: Record<string, unknown> }): string | null {
  const kind = node.props?.kind as string | undefined;
  const ownerId = node.props?.ownerId as number | undefined;
  if (!kind) return null;
  return unitTexturePath(kind, ownerId);
}

/** Build a preview URL for a city scene node. */
export function cityPreviewUrl(node: { props?: Record<string, unknown> }): string | null {
  const tier = (node.props?.tier as number | undefined) ?? 1;
  const ownerId = node.props?.ownerId as number | undefined;
  return cityTexturePath(tier, ownerId);
}
